export const canvasSizePresets = Object.freeze([
  { value: 'desktop', label: '桌面', icon: 'el-icon-monitor', width: 1920, height: 1080 },
  { value: 'tablet', label: '平板', icon: 'el-icon-notebook-2', width: 1024, height: 768 },
  { value: 'mobile', label: '手机', icon: 'el-icon-mobile-phone', width: 390, height: 844 },
  { value: 'custom', label: '自定义', icon: 'el-icon-set-up' }
])

export const pageFitTypes = Object.freeze(['平铺', '等比例', '等宽', '等高'])

export const pageFitDescriptions = Object.freeze({
  平铺: '铺满显示区域，宽高分别拉伸。',
  等比例: '保持比例完整显示，空余区域留白。',
  等宽: '按显示区域宽度适配，高度可能超出。',
  等高: '按显示区域高度适配，宽度可能超出。'
})

// 只解释界面状态，不在打开旧页面时自动补写新字段。
export function selectedCanvasSize (config = {}) {
  if (config.canvasSize === 'custom') return 'custom'
  if (config.canvasSize && !canvasSizePresets.some(preset => preset.value === config.canvasSize)) return 'custom'
  const preset = canvasSizePresets.find(preset => preset.width === Number(config.width) && preset.height === Number(config.height))
  return preset ? preset.value : 'custom'
}

export function selectedPageFit (config = {}) {
  return pageFitTypes.includes(config.fitType) ? config.fitType : '等比例'
}

function changedPatch (config, patch) {
  return Object.keys(patch).some(key => config[key] !== patch[key]) ? patch : null
}

export function canvasSizePatch (config, value) {
  const preset = canvasSizePresets.find(preset => preset.value === value)
  if (!preset) return null
  const patch = { canvasSize: value }
  if (preset.width) Object.assign(patch, { width: preset.width, height: preset.height })
  return changedPatch(config, patch)
}

export function canvasDimensionPatch (config, axis, value) {
  if (!['width', 'height'].includes(axis) || !validCanvasDimension(value)) return null
  const dimension = Number(value)
  if (Number(config[axis]) === dimension) return null
  return { [axis]: dimension, canvasSize: 'custom' }
}

export function validCanvasDimension (value) {
  return ['number', 'string'].includes(typeof value) && String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 1
}

export function pageFitPatch (config, value) {
  return pageFitTypes.includes(value) ? changedPatch(config, { fitType: value }) : null
}

// 84×48 的局部示意图，不参与画布、节点或正式预览的尺寸计算。
export function pageFitPreview (config = {}) {
  const width = Number(config.width), height = Number(config.height)
  const ratio = width > 0 && height > 0 && Number.isFinite(width) && Number.isFinite(height)
    ? Math.max(0.01, Math.min(100, width / height)) : 16 / 9
  let w = 84, h = 48
  switch (selectedPageFit(config)) {
  case '等比例':
    w = Math.min(84, 48 * ratio)
    h = w / ratio
    break
  case '等宽':
    h = 84 / ratio
    break
  case '等高':
    w = 48 * ratio
    break
  }
  return { left: (84 - w) / 2, top: (48 - h) / 2, width: w, height: h }
}
